import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    if (window.top !== window.self) {
      window.top.location.href = window.self.location.href;
    }
  }
}
